export enum StepStatus {
  Pending = "pending",
  Current = "current",
  Complete = "complete",
  Locked = "locked",
}
